/**
 * The languages supported by the app.
 * @type {{
 *  ES: string,
 *  EN: string,
 *  GB: string,
 * }}
 */
export const LANGUAGES = {
    ES: 'es-ES',
    EN: 'en-EN',
    GB: 'en-GB',
};
